export default [
  {
    path: '/activity-20250728-main',
    component: () => import('./Main.vue'),
    meta: { id: 138, expire: '2025-08-06T23:59:59.000+08:00', title: '夏季盛典·逐梦荣耀星光' },
  },
  {
    path: '/activity-20250728-rule',
    component: () => import('./Rule.vue'),
    meta: { id: 139, expire: '2025-08-06T23:59:59.000+08:00', title: '夏季盛典·逐梦荣耀星光' },
  },
]
